'use client'

import { useEffect, createContext, useContext, useState } from 'react';
import axios from 'axios';

const OpalContext = createContext();

export default function OpalProvider({ children }) {

    const [title, setTitle] = useState(" "); 
    const [allowedFeatures, setAllowedFeatures] = useState([]);
    const [loadingFeatures, setLoadingFeatures] = useState(true);
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        loadPermittedFeatures();
        loadPermissions();
    }, []);

    const loadPermittedFeatures = async () => {
        try {

            const response = await axios.get(`api/features`);

            if (response && response.status === 200) {
                const features = response.data.message;
                setAllowedFeatures(features);
            }

            
        } catch (error) {
            console.error('Error getting features', error);

            return error;
        } finally {
            setLoadingFeatures(false);
        }
    };


    const loadPermissions = async () => {
        try {

            const response = await axios.get(`api/permissions`);
           
            if (response && response.status === 200) {
                const features = response.data.message;
                setPermissions(features);
            }

        } catch (error) {
            console.error('Error getting permissions', error);

            return error;
        } 
    };

    return (
        <OpalContext.Provider value={{ title, setTitle, allowedFeatures, loadingFeatures, permissions }}>
            {children}
        </OpalContext.Provider>
    );
};

export function useOpalContext() {
    return useContext(OpalContext);
}

